import { combineReducers } from "redux";
import walletConnection from '../reducers/walletConnection';
import balances from '../reducers/balances';

export default combineReducers({
    walletConnection,
    balances
});